import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import CustomTable from '../../../shared/components/table/custom-table';
import { FloatingButtonContainer, InnerButton } from '../../../shared/components/buttons/floating-button-container';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import useNotification from '../../../shared/hooks/useNotification';
import { useApi } from '../../../shared/hooks/useApi';
import { LoaderComponent } from '../../../shared/components/loaders/page-loader';
import _ from 'lodash';
import { ETCAppConfig } from '../../../shared/app-configs/etc-app-configs';
import { mapPayload } from '../etc-models/IInputEtcProduct-model';
import { Utills } from '../../../shared/app-configs/utilit';
import { StyledButton } from '../../../shared/components/buttons/custom-button';

const InputEtcProductDetails = () => {
  const { notify } = useNotification()
  const navigate = useNavigate();
  const { etcId, formtype } = useParams<string>()
  const [data, setData] = useState<any[]>([]);
  const { loading, executeGet } = useApi();
  // Refs for Form Steps
  const componentInfoRef = useRef<any>(null);
  const formRefs = [componentInfoRef];

  const fetchComponentDetails = async () => {
    try {
      Utills.cl("ETCAppConfig.GET_INPUT_ETC_PRODUCT_DETAILS", ETCAppConfig.GET_INPUT_ETC_PRODUCT_DETAILS)
      const response: any = await executeGet(ETCAppConfig.GET_INPUT_ETC_PRODUCT_DETAILS, { etcId: etcId });
      Utills.cl("response", response)
      const result = mapPayload(response.data.inputTcInformation, etcId);
      Utills.cl("result", result.inputTcInformation)
      setData(result.inputTcInformation);
    } catch (err) {
      console.error('Failed to fetch Input Etc Product Details:', err);
    }
  }

  useEffect(() => {
      fetchComponentDetails()
  }, []);

  const columns: MRT_ColumnDef<any>[] = [
    { accessorKey: 'inputTcProductNo', header: 'Input eTC Product No.', enableHiding: false, minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductArticleNo', header: 'Input eTC Product Article No.', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductNumberOfUnits', header: 'Input eTC Product Number of Units', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductUnitsMetric', header: 'Input eTC Component Product Unit Metric', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductProductionDate', header: 'Input eTC Product Production Date', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductCategoryCode', header: 'Input eTC Product Category Code', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductCategoryUserSpecificTerm', header: 'Input eTC Product Category User Specific Term', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductDetailCode', header: 'Input eTC Product Detail Code', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductDetailUserSpecificTerm', header: 'Input eTC Product Detail User Specific Term', minSize: 60, maxSize: 150 },
  ];
  const handleSave = async () => {
    navigate(`/etc/${formtype}/declaration-submit-details/${etcId}`)
  }
  const renderDetailPanel = ({ row }: { row: any }) => {
    Utills.cl(data[0]?.inputTcProductInformation[0]?.inputTcProductStandardInformation)
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 5,
          gap: 4,
          width: '80%',
        }}
      >
        {/* Product Component Standard Information */}
        <Box sx={{ width: '100%', textAlign: 'left', mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            Input eTC Product Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'inputTcProductInfoTrimsExcluded',
                header: 'Input eTC Product Info Trims Excluded',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoAssociatedTc',
                header: 'Input eTC Product Info Associated eTC',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoFiberLength',
                header: 'Input eTC Product Info Fiber Length',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoYarnCount',
                header: 'Input eTC Product Info Yarn Count',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoFabricWeightAndConstruct',
                header: 'Input eTC Product Info Fabric Weight and construct',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoFabricWeightOfFinishedProduct',
                header: 'Input eTC Product Info Fabric Weight of Finished Product',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductInfoAdditional',
                header: 'Input eTC Product Info Additional',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={data[0].inputTcProductInformation}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Product Component Standard Information */}
        <Box sx={{ width: '100%', textAlign: 'left' }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
          Product Component Standard Information
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'inputTcProductStandardLabelGrade',
                header: 'Standard Label Grade',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductCertifiedWeight',
                header: 'Certified Weight (kg)',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductCertifiedWeightUsed',
                header: 'Certified Weight Used (kg)',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={data[0].inputTcProductInformation[0].inputTcProductStandardInformation}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Raw Material Composition */}
        <Box sx={{ width: '100%', textAlign: 'left' }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            Raw Material Composition
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'inputTcProductRawMaterialCode',
                header: 'Raw Material Code',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcProductRawMaterialPercentage',
                header: 'Raw Material Percentage',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={data[0].inputTcProductInformation[0].inputProductRawMaterialInformation}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
      </Box>
      
    );
  };
  Utills.cl(data)

  return (
    <>
      {loading ? <LoaderComponent /> : <>
        <Box display="grid">
          <CustomTable
            columns={columns}
            data={data[0]?.inputTcProductInformation}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            renderDetailPanel={renderDetailPanel}
          />
        </Box>
        <Box sx={{
          display: "flex", justifyContent: "flex-end", mt: 2
        }}>
          <StyledButton variant="contained" onClick={handleSave}>
            Next
          </StyledButton>
          <NavLink to="/tc-dashboard">
            <StyledButton variant="contained">
              Cancel
            </StyledButton>
          </NavLink>
        </Box>
      </>}
    </>
  );
};

export default InputEtcProductDetails;